import { css } from "@emotion/react";
import { media } from "styles/breakpoints";
import { theme } from "styles/theme";

export const SocialBoxStyle = {
  container: css`
    display: flex;
    position: fixed;
    top: 450px;
    ${media.xxl} {
      top: 410px;
    }
    right: 0;
    z-index: 999;
    transform: translateY(-50%) translateX(175px);
    color: white;

    ${media.sm} {
      display: none;
    }
  `,
  blockList: css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 10px;
  `,
  blockItem: (isCheckPhone: boolean) => css`
    display: flex;
    transition: 0.3s;
    gap: 4px;
    background-color: ${theme.colors.secondary[800]};
    width: 100%;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    transition: all 0.3s ease;
    cursor: ${isCheckPhone ? "pointer" : "initial"};

    &:hover {
      transform: translateX(-175px);
      transition: all 0.3s ease;
    }
  `,
  blockContent: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 4px;
    width: 100%;
  `,

  image: css`
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
  `,
  title: css`
    margin: 0 10px;
    padding: 5px 30px;
    color: ${theme.colors.white};
    font-size: 24px;
    border-radius: 35px;
    background-color: ${theme.colors.neutrals[750]};

    text-align: center;
  `,
};
